<!-- eslint-disable -->
<template lang="pug">
    div
        .row.info-preview(v-if="user.isSuperadmin || user.isManagerOrSupport")
            template(v-if="!isLoading && summary")
                .col-xs-12.col-md-6.col-xl-3.info-preview__column
                    .info-preview__item
                        svg-icon.info-preview__icon(name="university", size="large")
                        .info-preview__info
                            .info-preview__title
                                | {{ $i18n.t('list.list_billing_activeSchools') }}
                            .info-preview__subtitle
                                | {{ summary.schools }}
                .col-xs-12.col-md-6.col-xl-3.info-preview__column
                    .info-preview__item
                        svg-icon.info-preview__icon(name="student", size="large")
                        .info-preview__info
                            .info-preview__title
                                | {{ $i18n.t('list.list_billing_activeStudents') }}
                            .info-preview__subtitle
                                | {{ summary.students }}
                .col-xs-12.col-md-6.col-xl-3.info-preview__column
                    .info-preview__item
                        svg-icon.info-preview__icon(name="money", size="large")
                        .info-preview__info
                            .info-preview__title
                                | {{ $i18n.t('list.list_billing_schoolsBalance') }}
                            .info-preview__subtitle
                                | {{ balanceString(summary.balance) }}
                .col-xs-12.col-md-6.col-xl-3.info-preview__column
                    .info-preview__item
                        svg-icon.info-preview__icon(name="calendar-list", size="large")
                        .info-preview__info
                            .info-preview__title
                                | {{ $i18n.t('list.list_billing_nextPeriod') }}
                            .info-preview__subtitle
                                | {{ balanceString(summary.profit) }}
            cs-loader(v-if="isLoading")
        school-preview(
            v-for="record in items"
            :record="record"
            :key="record.id"
            :open-school-id="openSchoolId"
            @open="handleOpenOfSchool"
        )
</template>

<script>
    /*eslint-disable*/
    import {mapState} from 'vuex';
    import SchoolPreview from './Preview.vue';
    import SchoolApi from '../../../../api/school'

    export default {
        props: ['items', 'summary'],
        data() {
            return {
                isLoading: false,
                openSchoolId: null,
            }
        },
        computed: {
            ...mapState({
                user: state => state.auth.user
            }),
        },
        components: {
            SchoolPreview
        },
        mounted() {
          (this.user.isSuperadmin || this.user.isManagerOrSupport) && !this.summary && this.fetchData();
        },
        methods: {
            fetchData () {
                this.isLoading = true;
                SchoolApi.getSchoolsSummary()
                .then(data => {
                    this.isLoading = false;
                    this.$emit('getSummary', data)
                })
                .catch(err => {
                    this.isLoading = false;
                })
            },
            balanceString (amount) {
                const formatter = new Intl.NumberFormat('ru-RU', {
                    style: 'currency',
                    currency: 'RUB',
                    minimumFractionDigits: 0,
                    maximumFractionDigits: 2,
                });
                return formatter.format(amount);
            },
            handleOpenOfSchool (event) {
                this.openSchoolId = this.openSchoolId === event ? null : event;
            }
        }
    }
</script>

<style scoped lang="scss">
    .info-preview {
        background-color: $x-color-white;
        border: 1px solid $x-color-gray-5;
        border-radius: $border-radius-8;
        margin: 0 0 8px;
        padding: 16px;
    }

    .info-preview__column {
        display: flex;
        flex-direction: column;
        justify-content: center;
        padding: 0;
    }


    .info-preview__item {
        display: flex;
        align-items: center;

        font-size: 13px;
        line-height: 16px;

        padding: 4px;
    }

    .info-preview__title {
        font-weight: 500;
    }

    .info-preview__info {
        margin-left: 8px;
    }

    .info-preview__icon {
        color: $hsl-color-green-58;
    }
</style>
